import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_LOCATION_API;

const containerStyle = {
  width: "100%",
  height: "400px",
};

const defaultLocation = {
  lat: -34.397,
  lng: 150.644,
};

const GoogleMapComponent = ({ relativeLocation, onAddressChange }) => {
  const [location, setLocation] = useState(defaultLocation);
  const [addressDetails, setAddressDetails] = useState(null);

  const extractAddressComponents = (addressComponents) => {
    let street = "";
    let city = "";
    let state = "";
    let postalCode = "";
    let country = "";

    addressComponents.forEach((component) => {
      if (component.types.includes("street_number")) {
        street += component.long_name + " ";
      }
      if (component.types.includes("route")) {
        street += component.long_name;
      }
      if (component.types.includes("locality")) {
        city = component.long_name;
      }
      if (component.types.includes("administrative_area_level_1")) {
        state = component.long_name;
      }
      if (component.types.includes("postal_code")) {
        postalCode = component.long_name;
      }
      if (component.types.includes("country")) {
        country = component.long_name;
      }
    });

    return {
      street,
      city,
      state,
      postalCode,
      country,
    };
  };

  const getAddressFromCoordinates = async (lat, lng) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAPS_API_KEY}`
      );
      const data = await response.json();
      if (data.results.length > 0) {
        const fullAddress = data.results[0].formatted_address;
        const addressComponents = extractAddressComponents(
          data.results[0].address_components
        );

        const googleMapUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

        const jsonAddress = {
          fullAddress,
          street: addressComponents.street,
          city: addressComponents.city,
          state: addressComponents.state,
          postalCode: addressComponents.postalCode,
          country: addressComponents.country,
          lat: lat,
          lng: lng,
          googleMapUrl: googleMapUrl,
        };

        setAddressDetails(jsonAddress);
        onAddressChange(jsonAddress); // Call the callback with the new address details
      } else {
        console.error("No address found for the given coordinates.");
      }
    } catch (error) {
      console.error("Error fetching address from coordinates", error);
    }
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    // setLocation({ lat, lng });
    getAddressFromCoordinates(lat, lng);
  };

  useEffect(() => {
    if (relativeLocation) {
      getCoordinatesFromLocation(relativeLocation);
    }
  }, [relativeLocation]);

  const getCoordinatesFromLocation = async (location) => {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${location}&key=${GOOGLE_MAPS_API_KEY}`
      );
      const data = await response.json();
      if (data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;
        setLocation({ lat, lng });
        getAddressFromCoordinates(lat, lng); // Get address details based on the coordinates
      } else {
        console.error("No location found.");
      }
    } catch (error) {
      console.error("Error fetching coordinates", error);
    }
  };

  return (
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={location}
        zoom={14}
        onClick={handleMapClick}
      >
        <Marker position={location} />
      </GoogleMap>
      {/* {addressDetails && (
        <div>
          <h4>Address Data in JSON Format:</h4>
          <pre>{JSON.stringify(addressDetails, null, 2)}</pre>
        </div>
      )} */}
    </LoadScript>
  );
};

export default GoogleMapComponent;
